import '@angular/localize/init';
export * from './lib/feature-tax-muma-details.module';

export * from './lib/tax-muma-details/feature-tax-muma-details.component';
